import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import cn from 'classnames';
import withStyles from 'react-jss';
var styles = {
  border: {
    transition: 'left 225ms cubic-bezier(0, 0, 0.2, 1) 0ms, width 225ms cubic-bezier(0, 0, 0.2, 1)'
  }
};

var ActiveTabBottomBorder = function ActiveTabBottomBorder(_ref) {
  var classes = _ref.classes,
      width = _ref.width,
      position = _ref.position,
      style = _ref.style;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('absolute bottom-0 bb-2 transition-left border-blue text-blue', classes.border),
    style: _extends({
      width: width,
      left: position
    }, style),
    "data-qa": "active-tab-bottom-border"
  });
};

export default withStyles(styles)(ActiveTabBottomBorder);